import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusCircle, Trash2, Loader2, ChevronRight, Crown } from 'lucide-react'; 
import axios from 'axios';
import './MemoiresNonMentionnes.css'; // Tu peux réutiliser ce CSS ou créer MemoiresPremium.css

// On récupère onThesisClick depuis les props
function MemoiresPremium({ onThesisClick }) {
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem("role") === "admin";

  const [premiumTheses, setPremiumTheses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMemoires = async () => {
      try {
        setLoading(true);
        // On interroge la nouvelle route Premium
        const res = await axios.get("https://api.memofacdz.com/api/memoires-premium");
        setPremiumTheses(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Erreur lors du fetch:", err);
        setError("Impossible de charger les mémoires Premium.");
        setLoading(false);
      }
    };
    fetchMemoires();
  }, []);

  const handleDelete = async (id, title, e) => {
    // IMPORTANT : on arrête la propagation pour ne pas ouvrir les détails en supprimant
    e.stopPropagation(); 
    if (window.confirm(`Voulez-vous vraiment supprimer le mémoire Premium "${title}" ?`)) {
      try {
        const token = localStorage.getItem("token");
        await axios.delete(`https://api.memofacdz.com/api/memoires-premium/${id}`, {
         headers: { Authorization: `Bearer ${token}` }
        });
        setPremiumTheses(premiumTheses.filter(t => t._id !== id));
        alert("Mémoire Premium supprimé !");
      } catch (err) {
        alert("Erreur lors de la suppression.");
      }
    }
  };

  return (
    <div className="memoires-non-mentionnes-page">
      <section className="theses-content-wrapper">
        <main className="theses-main-content">
          <div className="theses-header">
            {/* Titre avec une petite couronne pour le style */}
            <h1 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Crown size={28} color="#ffc107" /> Mémoires Premium
            </h1>
            

            <p className="subtitle">
              Cette section liste les mémoires exclusifs réservés aux comptes VIP.
            </p>
          </div>
          
          <div className="theses-list">
            {loading && (
              <div className="loading-state">
                <Loader2 className="spinner" /> Chargement des mémoires Premium...
              </div>
            )}

            {error && <p className="error-message">{error}</p>}

            {!loading && premiumTheses.length === 0 && <p>Aucun mémoire Premium trouvé.</p>}

            {!loading && premiumTheses.map((thesis) => (
              /* On rend la carte cliquable avec onThesisClick */
              <div 
                key={thesis._id} 
                className="thesis-card clickable-card"
                onClick={() => onThesisClick && onThesisClick(thesis)}
                style={{ borderLeft: '4px solid #ffc107' }} // Petite touche visuelle premium
              >
                <div className="thesis-card-content">
                
                  {thesis.Couverture_R && (
                      <img 
                        src={`https://api.memofacdz.com${thesis.Couverture_R}`} 
                        alt="Couverture" 
                        className="thesis-mini-cover" 
                      />
                    )}
                    <div className="thesis-card-info">
                  {/* On affiche intitule_R au lieu de intitule_M */}
                  <h3>{thesis.intitule_R || "Titre non défini"}</h3>
                  <p>Auteur: <strong>{thesis.Ecrivain}</strong> </p>
                  
                  {/* Optionnel : On affiche les Axes s'il y en a (puisqu'on ne montre plus les mots clés) */}
                  {thesis.Axes && thesis.Axes.length > 0 && (
                    <p style={{ fontSize: '0.85rem', color: '#666', marginTop: '5px' }}>
                      Axes : {thesis.Axes.join(', ')}
                    </p>
                  )}
                </div>
                </div>

                <div className="card-actions">
                  <span className="click-instruction">Détails <ChevronRight size={14}/></span>
                  
                  {isAdmin && (
                    <button 
                      className="delete-memoire-btn"
                      onClick={(e) => handleDelete(thesis._id, thesis.intitule_R, e)} // intitule_R pour le message de confirmation
                    >
                      <Trash2 size={20} />
                    </button>
                  )}
                </div>
              </div>
            ))}
            

          </div>
        </main>
      </section>
    </div>
  );
}

export default MemoiresPremium;